import DesktopHeader from '../../header/DesktopHeader';
import MapPanelLayoutDesktop from './MapPanelLayoutDesktop';
import DetailsLayoutDesktop from './DetailsLayoutDesktop';
import Footer from '../../Footer';
import constants from '../../../config/constants';

const { headerHeight, footerHeight } = constants;

const styles = {
  main: {
    height: `calc(100vh - ${headerHeight}px - ${footerHeight}px)`,
    width: '100vw',
    display: 'flex',
    // background: '#484848',
    // background: '#333',
    background: '#1B3664',
  },
};

const DesktopLayout = () => (
  <>
    <DesktopHeader height={headerHeight} />
    <main id="map-charts-wrapper" style={styles.main}>
      <MapPanelLayoutDesktop width={60} /> {/* filters, search, map */}
      <DetailsLayoutDesktop width={40} /> {/* stats, charts, etc */}
    </main>
    <Footer height={footerHeight} />
  </>
);

export default DesktopLayout;
